import { batch } from 'react-redux';
import IEntityApiService from 'services/entityApi/IEntityApiService';
import { AppDispatch } from 'storage';
import slices from 'storage/slices';
import { DICTIONARY_ENTITY_NAME } from 'typings/subEntities/dictionaries/dictionaries.enum';
import IDictionariesActionsService from './IDictionariesActionService';
import DictionaryMapper from 'utils/mappers/Dictionary';

// Объединяет получение и хранение всех словарей
export default class DictionariesActionsServiceImpl implements IDictionariesActionsService {
  constructor(
    private readonly entityApiService: IEntityApiService,
    private readonly sliceActions: typeof slices.dictionaries.actions,
    private readonly storageDispatch: AppDispatch,
    private readonly mapper: DictionaryMapper
  ) {}

  public async getList<T, DTO>({
    dictionaryName,
    path,
    entityMapper,
  }: {
    dictionaryName: DICTIONARY_ENTITY_NAME;
    path: string;
    entityMapper?: (entityDTO: DTO) => T;
  }) {
    this.startLoading(dictionaryName);
    const list = await this.entityApiService.getWithCredentials<DTO[]>(path).then((response) => {
      if (entityMapper) {
        return response.map(entityMapper);
      }
      switch (dictionaryName) {
        case DICTIONARY_ENTITY_NAME.orderContractType:
          return (response as OrderContractType[]).map(this.mapper.contractTypesResponseDTOToModel);
        default:
          return response;
      }
    });
    batch(() => {
      this.setList(dictionaryName, list);
      this.stopLoading(dictionaryName);
    });
  }

  private startLoading(dictionaryName: DICTIONARY_ENTITY_NAME) {
    this.storageDispatch(this.sliceActions.startLoading(dictionaryName));
  }
  private stopLoading(dictionaryName: DICTIONARY_ENTITY_NAME) {
    this.storageDispatch(this.sliceActions.stopLoading(dictionaryName));
  }
  private setList(dictionaryName: DICTIONARY_ENTITY_NAME, list: unknown[]) {
    this.storageDispatch(this.sliceActions.setList({ name: dictionaryName, list }));
  }

  public resetData(dictionaryName: DICTIONARY_ENTITY_NAME) {
    this.storageDispatch(this.sliceActions.resetData(dictionaryName));
  }
}
